"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceModule = exports.Service = exports.stationPath = exports.urlParams = void 0;

var maishu_chitu_service_1 = require("maishu-chitu-service");

var config = require("json!websiteConfig");

var maishu_toolkit_1 = require("maishu-toolkit");

exports.urlParams = {};
if (location.search) exports.urlParams = parseUrlParams(location.search.substr(1));
var protocol = location.protocol;
/** 站点路径 */

function stationPath(path) {
  console.assert(requirejs != null);
  var contexts = requirejs.exec("contexts");
  var contextName;
  if (config.requirejs) contextName = config.requirejs.context;
  var context = contexts[contextName];

  if (context != null && context.config != null && context.config.baseUrl != null) {
    return maishu_toolkit_1.pathConcat(context.config.baseUrl, path);
  }

  return path;
}

exports.stationPath = stationPath;

var Service = /*#__PURE__*/function (_maishu_chitu_service) {
  _inherits(Service, _maishu_chitu_service);

  var _super = _createSuper(Service);

  function Service() {
    _classCallCheck(this, Service);

    return _super.apply(this, arguments);
  }

  _createClass(Service, [{
    key: "ajax",
    value: function () {
      var _ajax = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, options) {
        var host, pathname, arr, r;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!url.startsWith("http")) {
                  host = location.host;
                  pathname = location.pathname;

                  if (!pathname.endsWith("/")) {
                    arr = pathname.split("/");
                    arr[arr.length - 1] = "";
                    pathname = arr.join("/");
                  }

                  if (url.startsWith("/")) {
                    url = "".concat(protocol, "//").concat(host).concat(url);
                  } else {
                    url = "".concat(protocol, "//").concat(host).concat(pathname).concat(url);
                  }
                }

                options = options || {};
                options.headers = options.headers || {};
                if (this.applicationId) options.headers['application-id'] = this.applicationId;
                _context.next = 6;
                return _get(_getPrototypeOf(Service.prototype), "ajax", this).call(this, url, options);

              case 6:
                r = _context.sent;

                if (r != null && r["Type"] == "DataSourceSelectResult") {
                  r["dataItems"] = r["DataItems"];
                  r["totalRowCount"] = r["TotalRowCount"];
                  r["maximumRows"] = r["MaximumRows"];
                  r["startRowIndex"] = r["StartRowIndex"];
                }

                return _context.abrupt("return", r);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function ajax(_x, _x2) {
        return _ajax.apply(this, arguments);
      }

      return ajax;
    }()
  }, {
    key: "localServiceUrl",
    value: function localServiceUrl(path) {
      var hash = location.hash;

      if (hash != null && hash[0] == "/") {
        hash = hash.substr(1);
        var arr = hash.split("/");
        var r = maishu_toolkit_1.pathConcat(arr[0], path);
        return r;
      }

      return path;
    }
  }, {
    key: "applicationId",
    get: function get() {
      return exports.urlParams.appKey;
    }
  }]);

  return Service;
}(maishu_chitu_service_1.Service);

exports.Service = Service;

function parseUrlParams(query) {
  if (!query) throw new Error("Argument query is null or empty.");
  if (query[0] == '?') query = query.substr(1);

  var match,
      pl = /\+/g,
      // Regex for replacing addition symbol with a space
  search = /([^&=]+)=?([^&]*)/g,
      decode = function decode(s) {
    return decodeURIComponent(s.replace(pl, " "));
  };

  var urlParams = {};

  while (match = search.exec(query)) {
    urlParams[decode(match[1])] = decode(match[2]);
  }

  return urlParams;
}

var ServiceModule = /*#__PURE__*/function () {
  function ServiceModule(service) {
    _classCallCheck(this, ServiceModule);

    this.service = service;
  }

  _createClass(ServiceModule, [{
    key: "getByJson",
    value: function getByJson(url, data) {
      return this.service.getByJson(url, data);
    }
  }, {
    key: "putByJson",
    value: function putByJson(url, data) {
      return this.service.putByJson(url, data);
    }
  }, {
    key: "postByJson",
    value: function postByJson(url, data) {
      return this.service.postByJson(url, data);
    }
  }, {
    key: "deleteByJson",
    value: function deleteByJson(url, data) {
      return this.service.deleteByJson(url, data);
    }
  }, {
    key: "get",
    value: function get(url, data) {
      return this.service.get(url, data);
    }
  }, {
    key: "put",
    value: function put(url, data) {
      return this.service.put(url, data);
    }
  }, {
    key: "post",
    value: function post(url, data) {
      return this.service.post(url, data);
    }
  }, {
    key: "delete",
    value: function _delete(url, data) {
      return this.service.delete(url, data);
    }
  }]);

  return ServiceModule;
}();

exports.ServiceModule = ServiceModule;
